import React from "react";
import * as c from '../../../../../../constants.jsx';
import axios from "axios";
import Grid from '@mui/material/Grid';
import ActionAlert from "../../../../../../components/Alert/ActionAlert.jsx";
import CardMarkerSmall from '../../../../../../components/CockpitCards/CardMarkerSmall.jsx';
import ButtonGeneGrey from "../../../../../../components/Button/ButtonGeneGrey.jsx";
import VariantCardAccordion from "../../../../../../components/TextComps/VariantCardAccordion.jsx";


export default function ComplexNoStarsCard() {

  const url_variantrisk = `${c.API_URL}/api/masterrisknostars` 

  const [variantInfo, setVariantInfo] = React.useState(null);
  const [error, setError] = React.useState(null);
      
      React.useEffect(() => {
        retrieveVariantPheno();
      }, []);
      
      const retrieveVariantPheno = () => {
        axios
          .get(url_variantrisk)
          .then((res) => {
            setVariantInfo(res.data);
      
          })
          .catch(function (error) {
            if (error.response) {
              // Request made and server responded
              setError(error.response.data);
            } else if (error.request) {
              // The request was made but no response was received
              setError("The request was made but no response was received.");
            } else {
              // Something happened in setting up the request that triggered an Error
              setError("Error: " + error.message);
            }
          });
      };

return(
<>

{variantInfo ? (

<CardMarkerSmall

  headline = "COMMON COMPLEX DISORDER" 
  subtext = {"Note that variants listed here currently don't have enough evidence to get stars in clinvar."}
  
  cardlines = {<>

    {variantInfo.map((i) => (
        
        <VariantCardAccordion key={i.id} 
        
                   marker = {<ButtonGeneGrey name={i.SYMBOL} /> }
                    gene = {i.SYMBOL} 
                    gene_name={i.GeneName}
                    MANE_SELECT={i.MANE_SELECT}
                    location={i.Uploaded_variation}
                    group={i.BIOTYPE}
                    variation={"Variant"}
                    var_g={i.HGVSg}
                    consequence={i.Consequence}
                    var_p={i.HGVSp}
                    gt={"-"} 
                    type={i.VARIANT_CLASS}
                    exon={i.EXON}
                    rs={i.RS}
                    expert={i.CLNREVSTAT}
                    classification={i.CLNSIG}
                    clinvarID={i.clinvarID}
                    pheno={"Phenotype"}
                    pheno_name={i.CLNDN}
         />  
))}   
</>  }
/>

) : (

    <Grid mt={2} mb={2} justifyContent="center" container spacing={2}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
        <ActionAlert
            severity="warning"
            message={"Currently no information available"}
        />
        </Grid>
    </Grid>

)
}

{error && (
          <Grid mt={2} mb={1} justifyContent="center" container spacing={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <ActionAlert severity="error" message={error.message} />
            </Grid>
          </Grid>
)}

</> 
)
}

